export default "__VITE_ASSET__d305d169__"